import MultiCounterControl from './MultiCounterControl';

export default MultiCounterControl;
